/**
 * Orders routing module (orders-routing.module.ts).
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.26.0 OAUI-416 Add basic QR code order management route
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  Templates403AccessDeniedComponent,
  Templates404NotFoundComponent,
} from 'ng-library-style-guide/dist/bc-style-guide';

const routes: Routes = [
  { path: '403', component: Templates403AccessDeniedComponent },
  { path: '404', component: Templates404NotFoundComponent },
  { path: '**', redirectTo: '404' }, // Any unknown routes navigate to 404 not found error page
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorsRoutingModule {}
